export class GenerateImageUrl {

  static execute(photoUrl: string): string {
    if (!photoUrl) return null;
    const timestamp = new Date().getTime().toString();
    return `${photoUrl}?${timestamp}`;
  }
}